import { SettingsApi } from '~/services/settings/settingsApi';

import type { FeatureFlag } from '~/common/types/settings';

export const getFeatureFlags = async (): Promise<FeatureFlag[]> => {
  try {
    const featureFlags = await SettingsApi.getFeatureFlags();

    return Object.entries(featureFlags.data).map(([name, value]) => ({
      name,
      value,
    }));
  } catch (error) {
    return [];
  }
};
